import {ChangeDetectionStrategy, Component, inject, OnInit, output, OutputEmitterRef, signal, WritableSignal} from '@angular/core';
import {AiChatService} from '../../../services/ai/ai-chat.service';
import {SnackbarService} from '../../../services/snackbar/snackbar.service';
import {PromptSuggestion} from '../../../bfa-api/models/prompt-suggestion';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonComponent} from '../../buttons/button/button.component';
import {AppButtonTypeEnum} from '../../../enums/button/app-button-type.enum';
import {PanelComponent} from '../panel.component';
import {IconsComponent} from '../../dummy-components/icons.component';
import {LoadingSpinnerComponent} from '../../loading-spinner/loading-spinner.component';
import {IconComponent} from '../../icon/icon.component';
import {AppIconSizeEnum} from '../../../enums/app-icon-size.enum';

@Component({
    selector: 'app-prompt-suggestions-panel',
    templateUrl: './prompt-suggestions-panel.component.html',
    styleUrl: './prompt-suggestions-panel.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        ButtonComponent,
        PanelComponent,
        LoadingSpinnerComponent,
        IconComponent
    ]
})
export class PromptSuggestionsPanelComponent extends IconsComponent implements OnInit {
    public panelClosed: OutputEmitterRef<void> = output();
    protected promptSuggestions: WritableSignal<PromptSuggestion[]>;
    protected isLoading: WritableSignal<boolean>;
    protected readonly AppButtonTypeEnum = AppButtonTypeEnum;
    protected readonly AppIconSizeEnum = AppIconSizeEnum;
    private readonly aiChatService = inject(AiChatService);
    private readonly snackbarService = inject(SnackbarService);

    public constructor() {
        super();
        this.promptSuggestions = signal([]);
        this.isLoading = signal(false);
    }

    public ngOnInit(): void {
        this.getPromptSuggestions()
            .then();
    }

    protected async sendChatMessage(promptSuggestion: string): Promise<void> {
        this.closePanel();
        await this.aiChatService.submitChatMessage(promptSuggestion);
    }

    protected closePanel(): void {
        this.panelClosed.emit();
    }

    private async getPromptSuggestions(): Promise<void> {
        this.isLoading.set(true);
        try {
            this.promptSuggestions.set(await this.aiChatService.getPromptSuggestions());
        } catch (e) {
            this.snackbarService.showError('AI_CHAT.GENERATING_PROMPTS_ERROR', e as Error);
            this.closePanel();
        }

        this.isLoading.set(false);
    }
}
